<mj-record-form-container [Record]="record" [FormComponent]="this"
    (Navigate)="OnFormNavigate($event)"
    (DeleteRequested)="OnDeleteRequested()"
    (FavoriteToggled)="OnFavoriteToggled()"
    (HistoryRequested)="OnHistoryRequested()"
    (ListManagementRequested)="OnListManagementRequested()">

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="before-fields" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>

    <!-- ========================================
         FIELD PANELS
         ======================================== -->
    <!-- Details Section -->
    <mj-collapsible-panel
        SectionKey="details"
        SectionName="Details"
        Icon="fa fa-align-left"
        [Form]="this"
        [FormContext]="formContext">
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="CurrencyCode"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Name"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Symbol"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="IsActive"
            Type="checkbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="__mj_CreatedAt"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="__mj_UpdatedAt"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="CompanyID"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
            LinkType="Record"
        ></mj-form-field>

    </mj-collapsible-panel>

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="after-fields" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>

    <!-- ========================================
         RELATED ENTITY PANELS
         ======================================== -->

    <!-- Payments Section -->
    <mj-collapsible-panel
        SectionKey="payments"
        SectionName="Payments"
        Icon="fa fa-table"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('payments')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Payments','CurrencyID')"
                [NewRecordValues]="NewRecordValues('Payments','CurrencyID')"
                [AllowLoad]="IsSectionExpanded('payments')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('payments', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Accounting Schedules Section -->
    <mj-collapsible-panel
        SectionKey="accountingSchedules"
        SectionName="Accounting Schedules"
        Icon="fa fa-table"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('accountingSchedules')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Accounting Schedules','CurrencyID')"
                [NewRecordValues]="NewRecordValues('Accounting Schedules','CurrencyID')"
                [AllowLoad]="IsSectionExpanded('accountingSchedules')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('accountingSchedules', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Trial Balances Section -->
    <mj-collapsible-panel
        SectionKey="trialBalances"
        SectionName="Trial Balances"
        Icon="fa fa-table"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('trialBalances')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Trial Balances','CurrencyID')"
                [NewRecordValues]="NewRecordValues('Trial Balances','CurrencyID')"
                [AllowLoad]="IsSectionExpanded('trialBalances')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('trialBalances', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Accounting Entries Section -->
    <mj-collapsible-panel
        SectionKey="accountingEntries"
        SectionName="Accounting Entries"
        Icon="fa fa-table"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('accountingEntries')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Accounting Entries','CurrencyID')"
                [NewRecordValues]="NewRecordValues('Accounting Entries','CurrencyID')"
                [AllowLoad]="IsSectionExpanded('accountingEntries')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('accountingEntries', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Accounting Entry Lines Section -->
    <mj-collapsible-panel
        SectionKey="accountingEntryLines"
        SectionName="Accounting Entry Lines"
        Icon="fa fa-table"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('accountingEntryLines')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Accounting Entry Lines','CurrencyID')"
                [NewRecordValues]="NewRecordValues('Accounting Entry Lines','CurrencyID')"
                [AllowLoad]="IsSectionExpanded('accountingEntryLines')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('accountingEntryLines', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Orders Section -->
    <mj-collapsible-panel
        SectionKey="orders"
        SectionName="Orders"
        Icon="fa fa-table"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('orders')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Orders','CurrencyID')"
                [NewRecordValues]="NewRecordValues('Orders','CurrencyID')"
                [AllowLoad]="IsSectionExpanded('orders')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('orders', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Exchange Rates (Base Currency Code) Section -->
    <mj-collapsible-panel
        SectionKey="exchangeRatesBaseCurrencyCode"
        SectionName="Exchange Rates (Base Currency Code)"
        Icon="fa fa-table"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('exchangeRatesBaseCurrencyCode')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Exchange Rates','BaseCurrencyCode')"
                [NewRecordValues]="NewRecordValues('Exchange Rates','BaseCurrencyCode')"
                [AllowLoad]="IsSectionExpanded('exchangeRatesBaseCurrencyCode')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('exchangeRatesBaseCurrencyCode', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Exchange Rates (Quote Currency Code) Section -->
    <mj-collapsible-panel
        SectionKey="exchangeRatesQuoteCurrencyCode"
        SectionName="Exchange Rates (Quote Currency Code)"
        Icon="fa fa-table"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('exchangeRatesQuoteCurrencyCode')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Exchange Rates','QuoteCurrencyCode')"
                [NewRecordValues]="NewRecordValues('Exchange Rates','QuoteCurrencyCode')"
                [AllowLoad]="IsSectionExpanded('exchangeRatesQuoteCurrencyCode')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('exchangeRatesQuoteCurrencyCode', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <!-- Posting Groups Section -->
    <mj-collapsible-panel
        SectionKey="postingGroups"
        SectionName="Posting Groups"
        Icon="fa fa-table"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('postingGroups')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Posting Groups','CurrencyID')"
                [NewRecordValues]="NewRecordValues('Posting Groups','CurrencyID')"
                [AllowLoad]="IsSectionExpanded('postingGroups')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('postingGroups', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="after-related" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>
</mj-record-form-container>
        